(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ci-pillow-sticky-cart-fix"] && !Shopify.designMode) return;
  try {
    (() => {
    const syncFooter = () => {
      document.querySelectorAll('.shopify-section-group-main-footer-group').forEach((section) => {
        section.classList.add('shopify-section-footer');
      });
    };

    const initStickyButtons = () => {
      syncFooter();

      document.querySelectorAll('[data-ci-pillow-sticky-atc]:not([data-ci-pillow-sticky-ready])').forEach((root) => {
        const sourceButton = document.querySelector('[data-ci-pillow-single]');
        const stickyButton = root.querySelector('[data-ci-pillow-sticky-button]');
        const footer = document.querySelector('.shopify-section-footer');

        if (!sourceButton || !stickyButton) {
          return;
        }

        root.setAttribute('data-ci-pillow-sticky-ready', 'true');

        const syncButton = () => {
          stickyButton.innerHTML = sourceButton.innerHTML;
          stickyButton.disabled = sourceButton.disabled;

          const busy = sourceButton.getAttribute('aria-busy');
          if (busy === null) stickyButton.removeAttribute('aria-busy');
          else stickyButton.setAttribute('aria-busy', busy);

          const label = sourceButton.getAttribute('aria-label');
          if (label) stickyButton.setAttribute('aria-label', label);
        };

        const updateVisibility = () => {
          const sourceRect = sourceButton.getBoundingClientRect();
          const footerIsClear = !footer || footer.getBoundingClientRect().top > window.innerHeight;
          root.hidden = !(sourceRect.bottom <= 0 && footerIsClear);
        };

        let updateQueued = false;
        const queueVisibilityUpdate = () => {
          if (updateQueued) return;
          updateQueued = true;
          window.requestAnimationFrame(() => {
            updateQueued = false;
            updateVisibility();
          });
        };

        stickyButton.addEventListener('click', () => {
          if (!sourceButton.disabled) sourceButton.click();
        });

        new MutationObserver(syncButton).observe(sourceButton, {
          attributes: true,
          attributeFilter: ['aria-busy', 'aria-label', 'disabled'],
          childList: true,
          subtree: true,
          characterData: true
        });

        window.addEventListener('scroll', queueVisibilityUpdate, { passive: true });
        window.addEventListener('resize', queueVisibilityUpdate, { passive: true });

        syncButton();
        updateVisibility();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initStickyButtons, { once: true });
    } else {
      initStickyButtons();
    }

    document.addEventListener('shopify:section:load', initStickyButtons);

    new MutationObserver(() => {
      const pendingSticky = document.querySelector(
        '[data-ci-pillow-sticky-atc]:not([data-ci-pillow-sticky-ready])'
      );

      if (pendingSticky && document.querySelector('[data-ci-pillow-single]')) {
        initStickyButtons();
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
